import { render, staticRenderFns } from "./SearchResultsTable.vue?vue&type=template&id=296a9b18&"
import script from "./SearchResultsTable.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports